import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const OfertaCard = ({ oferta, user, isFavorite, onFavoriteToggle, likes = 0 }) => {
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  // Helper to safely format currency
  const formatPrice = (value) => {
    if (value === undefined || value === null) return "R$ --";
    return `R$ ${Number(value).toFixed(2)}`;
  };

  // Helper to calculate discount safely
  const getDiscountPercentage = () => {
    if (!oferta.precoOriginal || !oferta.precoDesconto) return 0;
    return Math.round(
      ((oferta.precoOriginal - oferta.precoDesconto) / oferta.precoOriginal) * 100
    );
  };

  const handleOfferClick = async (e) => {
    // Registrar visualização e interesse (paralelo)
    try {
      Promise.all([
        axios.post(`${process.env.REACT_APP_API_URL}/offers/${oferta.id}/view`),
        // Rastrear interesse por categoria localmente
        (async () => {
          if (oferta.categoria) {
            const interests = JSON.parse(localStorage.getItem('categoryInterests') || '{}');
            interests[oferta.categoria] = (interests[oferta.categoria] || 0) + 1;
            localStorage.setItem('categoryInterests', JSON.stringify(interests));
          }
        })()
      ]).catch(console.error);
    } catch (error) {
      console.error("Erro ao registrar interações:", error);
    }
  };



  const discountPercentage = getDiscountPercentage();
  const precoOriginal = oferta.precoOriginal;
  const precoDesconto = oferta.precoDesconto;
  const imageSrc = oferta.imagem || oferta.imagem_url;
  if (!imageSrc || imageError) return null;

  const finalImageSrc = imageSrc;

  return (
    <div style={{
      backgroundColor: 'var(--background-white)',
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
      border: '1px solid transparent',
      cursor: 'pointer'
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 7px 16px 0 rgba(0,0,0,0.11)';
        e.currentTarget.style.borderColor = 'rgba(0,0,0,0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.borderColor = 'transparent';
      }}
    >
      {/* Favorite Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          onFavoriteToggle(oferta.id);
        }}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'rgba(255, 255, 255, 0.9)',
          border: 'none',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 2,
          transition: 'all 0.2s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.background = 'white';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
        }}
      >
        <i className={isFavorite ? "fas fa-heart" : "far fa-heart"} style={{
          color: isFavorite ? 'var(--accent-color)' : 'var(--text-secondary)',
          fontSize: '16px'
        }}></i>
      </button>

      <Link
        to={`/oferta/${oferta.id}`}
        onClick={handleOfferClick}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        {/* Image Container */}
        <div style={{
          width: '100%',
          paddingTop: '85%',
          position: 'relative',
          backgroundColor: '#fff',
          overflow: 'hidden',
          borderBottom: '1px solid #eee'
        }}>
          <img
            key={finalImageSrc}
            src={finalImageSrc}
            alt={oferta.titulo}
            onError={() => setImageError(true)}
            loading="lazy"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              padding: 'var(--spacing-sm)'
            }}
          />

          {/* Like Badge */}
          <div style={{
            position: 'absolute',
            bottom: '8px',
            right: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '4px 8px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '11px',
            fontWeight: 'bold',
            color: 'var(--text-secondary)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 1
          }}>
            <i className="fas fa-thumbs-up" style={{ color: 'var(--primary-color)' }}></i>
            {likes}
          </div>
        </div>

        {/* Content */}
        <div style={{
          padding: '12px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: '6px'
        }}>
          <div>
            <span style={{
              fontSize: '10px',
              color: '#888',
              textTransform: 'uppercase',
              fontWeight: '700',
              letterSpacing: '0.05em'
            }}>
              {oferta.loja}
            </span>
          </div>

          <div style={{ marginTop: '2px' }}>
            <h3 style={{
              fontSize: '13px',
              color: '#444',
              margin: '0 0 4px 0',
              lineHeight: '1.2',
              fontWeight: '400',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              height: '32px',
              fontFamily: 'var(--font-main)',
              letterSpacing: '0'
            }}>
              {oferta.titulo}
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
              {precoOriginal > precoDesconto && (
                <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '11px' }}>
                  {formatPrice(precoOriginal)}
                </span>
              )}
              
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '5px', marginTop: '1px' }}>
                <span style={{ 
                  fontSize: '20px', 
                  fontWeight: '500', 
                  color: '#333',
                  fontFamily: 'var(--font-main)'
                }}>
                  {formatPrice(precoDesconto)}
                </span>
                {discountPercentage > 0 && (
                  <span style={{
                    color: '#00a650',
                    fontSize: '13px',
                    fontWeight: '400'
                  }}>
                    {discountPercentage}% OFF
                  </span>
                )}
              </div>

              {oferta.mostrar_parcelamento !== false && precoDesconto && (
                <div style={{ fontSize: '13px', color: '#00a650', fontWeight: '400', marginTop: '1px' }}>
                  10x {formatPrice(Number(precoDesconto) / 10)} sem juros
                </div>
              )}

            </div>
          </div>
        </div>
      </Link>


    </div>
  );
};

export default OfertaCard;
